<template>
  <v-row align="center" justify="center">
    <v-col md="6">
      <v-card :loading="loading" :disabled="loading">
        <v-card-title>
          Create User
        </v-card-title>
        <v-card-text>
          <validation-observer ref="validationObserver" slim>
            <result-user-api-form
              ref="form"
              v-model="user"
              :params="params"
              @submit="create"
            >
            </result-user-api-form>
          </validation-observer>
          <v-card-actions>
            <v-btn
              color="primary"
              @click="
                $router.push({ name: $routes.admin.resultApiUser.indexRoute.name })
              "
            >
              Back
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="create">
              Create
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { create } from "../../../../api/resultApiUser.api.js";
import ResultApiUserCreateUpdate from "./ResultApiUserCreateUpdate.js";
import ResultUserApiForm from '../../../components/resultApiUser/ResultApiUserForm.vue';

export default {
  name: "ResultApiUserCreate",
  components: { ResultUserApiForm },
  extends: ResultApiUserCreateUpdate,
  async mounted() {
    this.$startLoading();
    await this.fetchParams();
    this.$finishedLoading();
  },
  methods: {
    async create() {
      const valid = await this.$refs.validationObserver.validate();

      if (valid) {
        const { user, $routes, $router } = this;

        create(user)
          .then(() => {
            $router.push({ name: $routes.admin.resultApiUser.indexRoute.name });
          })
          .catch(error =>
            this.handleErrorResponse(this.$refs.validationObserver, error)
          );
      }
    }
  }
};
</script>

<style scoped></style>
